// Zentrale Whitelist "voller Kurszugriff via Enrollment-Source".
//
// WICHTIG (16.07.2026): 'legacy_import' ist BEWUSST NICHT enthalten.
// Diese Quelle markiert Alt-Homepage-Import-Artefakte, die nur den Zugriff
// wie 'tier_access' gewähren sollen (also nur mit passendem Tarif). Wird die
// Konstante hier erweitert, öffnet das schleichend Zugriff auf importierte
// Kurse — deshalb keine Änderung ohne explizite Freigabe der Konsistenz-
// Regeln.
//
// Referenz: Regel 10 in consistency_report()/reconcile-user-consistency.

export type EnrollmentSource =
  | "purchase"
  | "admin"
  | "bundle"
  | "free"
  | "gift"
  | "tier_access"
  | "subscription"
  | "legacy_import";

export const FULL_ACCESS_SOURCES = [
  "purchase",
  "admin",
  "bundle",
  "free",
  "gift",
] as const;

export type FullAccessSource = (typeof FULL_ACCESS_SOURCES)[number];

export function isFullAccessSource(
  source: string | null | undefined,
): source is FullAccessSource {
  if (!source) return false;
  return (FULL_ACCESS_SOURCES as readonly string[]).includes(source);
}
